import {
  Avatar,
  Box,
  Button,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { Modal } from "antd";
import { FaPlus } from "react-icons/fa";
import { Controller } from "Controller/Controller";
import React, { useMemo, useState, useEffect } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { Input, Divider, Popconfirm, InputNumber, Radio } from "antd";
import AddServiceModal from "./AddServiceModal";
import { Alert } from "components/Alert/Alert";

const { TextArea } = Input;

const ActionService = ({ row, handleUpdate }) => {
  const [openEdit, setOpenEdit] = useState(false);

  const [data, setData] = useState({
    name: "",
    cost: null,
    description: "",
    interval: "Monthly",
    interval_count: 1,
  });

  // repeat UI state (mirror AddServiceModal)
  const [repeatType, setRepeatType] = useState("month");
  const [dayCount, setDayCount] = useState(1);
  const [weekCount, setWeekCount] = useState(1);
  const [monthCount, setMonthCount] = useState(1);
  const [yearCount, setYearCount] = useState(1);

  useEffect(() => {
    console.log(row);
    setData(row);

    // derive repeatType and counts from incoming row.interval / interval_count
    let r = "month";
    let d = 1,
      w = 1,
      m = 1,
      y = 1;
    if (row && row.interval) {
      switch (row.interval) {
        case "OneTime":
          r = "none";
          break;
        case "Daily":
          r = "day";
          d = row.interval_count || 1;
          break;
        case "Weekly":
          r = "week";
          w = row.interval_count || 1;
          break;
        case "Monthly":
          r = "month";
          m = row.interval_count || 1;
          break;
        case "Annual":
          r = "year";
          y = row.interval_count || 1;
          break;
        default:
          r = "month";
          m = row.interval_count || 1;
      }
    }
    setRepeatType(r);
    setDayCount(d);
    setWeekCount(w);
    setMonthCount(m);
    setYearCount(y);
  }, [row]);

  // whenever the repeat UI changes, sync into data.interval & data.interval_count
  useEffect(() => {
    let newInterval = "";
    let newCount = 1;
    switch (repeatType) {
      case "none":
        newInterval = "OneTime";
        newCount = 1;
        break;
      case "day":
        newInterval = "Daily";
        newCount = dayCount;
        break;
      case "week":
        newInterval = "Weekly";
        newCount = weekCount;
        break;
      case "month":
        newInterval = "Monthly";
        newCount = monthCount;
        break;
      case "year":
        newInterval = "Annual";
        newCount = yearCount;
        break;
      default:
        newInterval = "Monthly";
        newCount = 1;
    }
    setData((prev) => ({
      ...prev,
      interval: newInterval,
      interval_count: newCount,
    }));
  }, [repeatType, dayCount, weekCount, monthCount, yearCount]);

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData({
      ...data,
      [name]: value,
    });
  };

  const handleDeleteService = async (e) => {
    const response = await Controller.DeleteService(row.id);
    console.log(response);
    console.log(response.detail);
    if (response.status < 250) {
      handleUpdate();
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
    } else {
      Alert.openNotification(
        response.json.detail ? response.json.detail : "Error",
        "error"
      );
    }
  };

  const editService = async () => {
    console.log(data);
    const response = await Controller.EditService(data);

    if (response.status < 250) {
      handleUpdate();
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
    } else {
      Alert.openNotification(
        response.json.detail ? response.json.detail : "Error",
        "error"
      );
    }
    handleCloseEdit();
  };

  const confirm = (e) => {
    console.log(e);
    handleDeleteService();
  };
  const cancel = (e) => {
    console.log(e);
  };

  return (
    <div>
      <span
        style={{ color: "orange", cursor: "pointer" }}
        onClick={() => {
          setOpenEdit(true);
        }}
      >
        Update
      </span>
      <Divider type="vertical" />
      <Popconfirm
        title="Delete the service"
        description="Are you sure to delete this service?"
        onConfirm={confirm}
        onCancel={cancel}
        okText="Yes"
        cancelText="No"
      >
        <span style={{ color: "red", cursor: "pointer" }}>Delete</span>
      </Popconfirm>
      <Modal
        title={"Update Service: " + data.name}
        visible={openEdit}
        footer={null}
        onCancel={handleCloseEdit}
      >
        <label className="formLabel">Service Name</label>
        <Input
          className={"inputs"}
          onChange={handleChange}
          type="text"
          name="name"
          placeholder="Service 1"
          value={data.name}
        />
        {/* <label className='formLabel'>Cost</label>
        <InputNumber
          value={data.cost}
          name="cost"
          defaultValue={0}
          formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={value => value.replace(/\$\s?|(,*)/g, '')}
          style={{ width: "100%" }}
          onChange={(e, value) => {
            console.log(e)
            setData(
              {
                ...data,
                cost: e
              }
            )
          }}
        /> */}

        {/* Replenish UI - same as Create modal */}
        <label className="formLabel">Services Will Be Replenished:</label>
        <div style={{ marginBottom: 8 }}>
          <Radio.Group
            value={repeatType}
            onChange={(e) => setRepeatType(e.target.value)}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Radio value="day" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={dayCount}
                onChange={setDayCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "day"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              day
            </Radio>
            <Radio value="week" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={weekCount}
                onChange={setWeekCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "week"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              week
            </Radio>
            <Radio value="month" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={monthCount}
                onChange={setMonthCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "month"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              month
            </Radio>
            <Radio value="year" style={{ marginBottom: 8 }}>
              Every{" "}
              <InputNumber
                min={1}
                value={yearCount}
                onChange={setYearCount}
                bordered={false}
                controls={false}
                disabled={repeatType !== "year"}
                style={{
                  width: "70px",
                  textAlign: "center",
                  borderBottom: "1px solid #000",
                  background: "transparent",
                }}
              />{" "}
              year
            </Radio>
          </Radio.Group>
        </div>
        <label className="formLabel">Description</label>

        <TextArea
          name="description"
          value={data.description}
          onChange={handleChange}
          autoSize={{ minRows: 3, maxRows: 5 }}
          placeholder="Description..."
        />
        <br />
        <p style={{ marginTop: "5px" }}>
          Note: This service may have been used before
        </p>
        <div
          className="btnBox"
          style={{ display: "flex", justifyContent: "end", marginTop: "15px" }}
        >
          <Button onClick={handleCloseEdit} type="secondary">
            Close
          </Button>
          <Button
            onClick={editService}
            type="primary"
            style={{ marginLeft: "5px" }}
          >
            Update
          </Button>
        </div>
      </Modal>
    </div>
  );
};

function ServiceTable(props) {
  console.log(props);

  const { columnsData, tableData } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  console.log("data");
  console.log(data);
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;
  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const textColor = useColorModeValue("navy.700", "white");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");

  // states
  const [open, setOpen] = useState(false);

  // functions

  const handleOpen = () => {
    setOpen(true);
  };

  const onCancel = (e) => {
    if (e) {
      props.updateData();
      setOpen(false);
    }
  };

  const handleUpdate = () => {
    props.updateData();
  };

  return (
    <>
      <Flex
        direction="column"
        w="100%"
        overflowX={{ sm: "scroll", lg: "hidden" }}
      >
        <Flex
          align={{ sm: "flex-start", lg: "center" }}
          justify="space-between"
          w="100%"
          px="22px"
          pb="20px"
          mb="10px"
          boxShadow="0px 40px 58px -20px rgba(112, 144, 176, 0.26)"
        >
          <Text color={textColor} fontSize="xl" fontWeight="600">
            Service List
          </Text>
          <Button
            ms="auto"
            align="center"
            justifyContent="center"
            bg={bgButton}
            _hover={bgHover}
            _focus={bgFocus}
            _active={bgFocus}
            w="37px"
            h="37px"
            onClick={handleOpen}
            lineHeight="100%"
            borderRadius="10px"
          >
            <Icon as={FaPlus} color={iconColor} w="24px" h="24px" />
          </Button>
        </Flex>

        <Table
          {...getTableProps()}
          variant="simple"
          color="gray.500"
          w="100%"
          tableLayout="fixed"
        >
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {columnsData.map((column, index) => {
                  if (column.Header === "Cost") {
                    return null;
                  }

                  const headerToDisplay =
                    column.Header === "Billing Interval"
                      ? "Replenishment Interval"
                      : column.Header;

                  const thWidth =
                    column.Header === "Name"
                      ? "20%"
                      : column.Header === "Billing Interval" ||
                        headerToDisplay === "Replenishment Interval"
                      ? "25%"
                      : column.Header === "Interval Count"
                      ? "15%"
                      : column.Header === "Description"
                      ? "30%"
                      : "10%";

                  return (
                    <Th
                      pe="10px"
                      key={index}
                      width={thWidth}
                      borderColor="transparent"
                      textAlign="left"
                    >
                      <Flex
                        justify="flex-start"
                        align="center"
                        fontSize={{ sm: "10px", lg: "12px" }}
                        color="gray.400"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                      >
                        {headerToDisplay}
                      </Flex>
                    </Th>
                  );
                })}
              </Tr>
            ))}
          </Thead>

          <Tbody>
            {props.tableData.map((row) => (
              <Tr key={row.id}>
                <Td width="20%">{row.name}</Td>

                {/* <Td>{"$ " + row.cost}</Td> */}

                <Td width="25%">
                  {row.interval.charAt(0).toUpperCase() + row.interval.slice(1)}
                </Td>
                <Td width="15%">{row.interval_count}</Td>
                <Td width="30%">{row.description}</Td>
                <Td width="10%">
                  <ActionService row={row} handleUpdate={handleUpdate} />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Flex>

      <AddServiceModal open={open} onCancel={onCancel} />
    </>
  );
}

export default ServiceTable;
